import NotificationAlert from './NotificationAlert';
import notificationService, { toNotificationType } from '../services/notificationService';
import { Notification } from '../types';

type NotificationStageProps = {
  notification: Notification;
  onClose: () => void;
  theme: 'light' | 'dark';
  donationTextTemplate: string;
  challengeTextTemplate: string;
  isPreview?: boolean;
};

const NotificationStage = ({
  notification,
  onClose,
  theme,
  donationTextTemplate,
  challengeTextTemplate,
  isPreview = false,
}: NotificationStageProps) => {
  const notificationType = toNotificationType(notification.notification_type);

  return (
    <NotificationAlert
      notification={notification}
      onClose={onClose}
      overlaySize={{ width: '100vw', height: '100vh' }}
      theme={theme}
      animationConfig={notificationService.getAnimationConfig(notificationType, theme)}
      donationTextTemplate={donationTextTemplate}
      challengeTextTemplate={challengeTextTemplate}
      isPreview={isPreview}
    />
  );
};

export default NotificationStage;
